function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IphoneOk = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 1H9C7.9 1 7 1.9 7 3V5C7 5.55 7.45 6 8 6C8.55 6 9 5.55 9 5V4H19V20H9V19C9 18.45 8.55 18 8 18C7.45 18 7 18.45 7 19V21C7 22.1 7.9 23 9 23H19C20.1 23 21 22.1 21 21V3C21 1.9 20.1 1 19 1Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01012 13.4688L5.09012 11.5487C4.74012 11.1988 4.17012 11.1988 3.82012 11.5487C3.47012 11.8987 3.47012 12.4688 3.82012 12.8187L6.29012 15.2888C6.68012 15.6788 7.31012 15.6788 7.70012 15.2888L13.5501 9.43875C13.9001 9.08875 13.9001 8.51875 13.5501 8.16875C13.2001 7.81875 12.6301 7.81875 12.2801 8.16875L7.01012 13.4688Z",
    fill: "#495057"
  }));
});